import { render } from "./activity-logs.vue?vue&type=template&id=b9fba996&scoped=true"
import script from "./activity-logs.vue?vue&type=script&lang=js"
export * from "./activity-logs.vue?vue&type=script&lang=js"

import "./activity-logs.vue?vue&type=style&index=0&id=b9fba996&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9fba996"]])

export default __exports__